import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {RequestMapperService} from "../../request-mapper.service";
import {StoryPreview} from "../../story/interface/story-preview";
import {StoryTransmissionService} from "../../raintree/transmission/story-transmission.service";
import {RouterLink} from "@angular/router";
import {PipeModule} from "../../pipe/pipe.module";

@Component({
	selector: 'fb-product-content-cards',
	standalone: true,
	imports: [CommonModule, RouterLink, PipeModule],
	templateUrl: './product-content-cards.component.html',
	styleUrls: ['./product-content-cards.component.scss']
})
export class ProductContentCardsComponent implements OnChanges {

	@Input()
	public productId: number = 0;
	@Input()
	isSizeMd: boolean = false;
	@Input()
	public madeToOrderEnabled: boolean = false;
	public storyPreview: StoryPreview[] = [];
	public loading: boolean = false;

	constructor(
		private _storyTransmissionService: StoryTransmissionService
	) {
	}

	public ngOnChanges(changes:SimpleChanges): void {
		if(changes['productId'] && this.productId)
			this.fetchContentList()
	}

	public fetchContentList(): void {
		let id: number = this.productId;
		this._storyTransmissionService.getStoryList(
			RequestMapperService.GET_RELATED_STORY_IN_PRODUCT_DETAILS + id,
			(): void => {
				this.loading = true;
			},
			(response: StoryPreview[]): void => {

				this.storyPreview = response;
				this.loading = false;
			},
			(): void => {
			},
			(error: string): void => {
			},
			(): void => {
			}
		)
	}
}
